import { __decorate } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    formData = {
        directionType: 1,
    };
    detail;
    onDetailChange(detail) {
        this.formData = { ...this.formData, ...detail };
    }
    mounted() {
        this.formData = { ...this.formData, ...this.detail };
    }
};
__decorate([
    Prop()
], default_1.prototype, "detail", void 0);
__decorate([
    Watch('detail')
], default_1.prototype, "onDetailChange", null);
default_1 = __decorate([
    Component({
        name: 'TheNumberOfStatistics',
    })
], default_1);
export default default_1;
